// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1l4GL","colBig":"styles_colBig__3Gpmg","colSmall":"styles_colSmall__2RVRx"};